<div class="analyze-gps-container">
  <!-- Карта сверху (фиксированная) -->
  <div class="map-section">
    <div class="card map-card">
        <div class="card-header">
          <div class="card-header-content">
            <div class="card-title-wrapper">
              <i class="fas fa-map-marked-alt card-icon"></i>
              <h5 class="card-title">Карта треков</h5>
            </div>
            <button 
              class="btn btn-clear" 
              (click)="clearMap()" 
              [disabled]="!selectedTrack"
              [class.disabled]="!selectedTrack"
              title="Убрать трек с карты">
              <i class="fas fa-times"></i>
              <span class="btn-text">Очистить</span>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div id="map" class="map-container"></div>
        </div>
        <div class="card-footer">
          <div class="controls-panel">
            <div class="controls-group">
              <label class="control-label">
                <i class="fas fa-crosshairs"></i>
                Точность (м)
              </label>
              <div class="input-wrapper">
                <input 
                  type="number" 
                  class="form-control accuracy-input"
                  [(ngModel)]="analyzeParameters.accuracy"
                  (ngModelChange)="onAccuracyChange()"
                  name="accuracy" 
                  placeholder="35" 
                  min="1" 
                  max="100" 
                  step="1">
              </div>
            </div>
            
            <button 
              class="btn btn-analyze" 
              (click)="analyze()" 
              [disabled]="isLoading"
              [class.loading]="isLoading">
              <i class="fas fa-sync-alt" [class.spinning]="isLoading"></i>
              <span>Анализировать</span>
            </button>

            <div class="timeline-control" *ngIf="selectedTrack">
              <div class="timeline-header">
                <i class="fas fa-clock"></i>
                <span class="timeline-label">Воспроизведение трека</span>
              </div>
              <div class="timeline-wrapper">
                <input
                  type="range"
                  class="timeline-slider"
                  [min]="0"
                  [max]="maxTimelineIndex"
                  [disabled]="maxTimelineIndex === 0"
                  [(ngModel)]="timelineIndex"
                  (ngModelChange)="onTimelineChange($event)"
                  name="timeline">
                <div class="timeline-time">
                  <i class="fas fa-map-pin"></i>
                  <span>{{ displayedPoints[timelineIndex]?.timestamp | date:'HH:mm:ss' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>

  <!-- Список участников снизу (с прокруткой) -->
  <div class="tracks-section">
    <div class="card tracks-card">
        <div class="card-header">
          <div class="card-header-content">
            <div class="card-title-wrapper">
              <i class="fas fa-users card-icon"></i>
              <h5 class="card-title">Треки участников</h5>
              <span class="badge badge-count" *ngIf="filteredTracks.length > 0">
                {{ filteredTracks.length }}
              </span>
            </div>
            <div class="header-actions">
              <div class="search-wrapper">
                <i class="fas fa-search search-icon"></i>
                <input 
                  type="text" 
                  class="form-control search-input"
                  placeholder="Поиск участника..."
                  [(ngModel)]="searchTerm">
                <button 
                  class="btn btn-clear-search" 
                  *ngIf="searchTerm"
                  (click)="searchTerm = ''"
                  title="Очистить поиск">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <button 
                class="btn btn-refresh" 
                (click)="reloadAll()" 
                [disabled]="isLoading"
                [class.loading]="isLoading"
                title="Обновить данные">
                <i class="fas fa-sync-alt" [class.spinning]="isLoading"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="table-container">
            <div class="table-empty" *ngIf="filteredTracks.length === 0">
              <i class="fas fa-inbox"></i>
              <p>Треки не найдены</p>
              <small *ngIf="searchTerm">Попробуйте изменить параметры поиска</small>
            </div>
            <table class="table tracks-table" *ngIf="filteredTracks.length > 0">
              <thead>
                <tr>
                  <th class="col-bib">№</th>
                  <th class="col-name">Участник</th>
                  <th class="col-points">Точек</th>
                  <th class="col-status">Статус</th>
                  <th class="col-actions">Действия</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let t of filteredTracks; let i = index">
                  <tr 
                    class="track-row" 
                    [class.selected]="selectedTrack === t"
                    [class.has-punches]="t?.waitingApprovePunches?.length > 0"
                    (click)="t.expanded = !t.expanded">
                    <td class="col-bib">
                      <span class="bib-number">{{ t?.participant?.bib || '-' }}</span>
                    </td>
                    <td class="col-name">
                      <div class="participant-info">
                        <div class="participant-name">
                          {{ t?.participant?.name }} {{ t?.participant?.surname }}
                        </div>
                      </div>
                    </td>
                    <td class="col-points">
                      <span class="points-count">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ t?.gpsTrack?.length || 0 }}
                      </span>
                    </td>
                    <td class="col-status">
                      <span 
                        class="badge badge-pending" 
                        *ngIf="t?.waitingApprovePunches?.length > 0"
                        [title]="t.waitingApprovePunches.length + ' панчей на проверке'">
                        <i class="fas fa-exclamation-circle"></i>
                        {{ t?.waitingApprovePunches?.length }}
                      </span>
                      <span class="badge badge-success" *ngIf="t?.waitingApprovePunches?.length === 0">
                        <i class="fas fa-check-circle"></i>
                        ОК
                      </span>
                    </td>
                    <td class="col-actions">
                      <button 
                        class="btn btn-map-action" 
                        (click)="showOnMap(t); $event.stopPropagation()" 
                        [disabled]="isLoading"
                        [class.active]="selectedTrack === t"
                        [title]="selectedTrack === t ? 'Скрыть трек' : 'Показать на карте'">
                        <i class="fas" [ngClass]="selectedTrack === t ? 'fa-eye-slash' : 'fa-map-marked-alt'"></i>
                      </button>
                    </td>
                  </tr>
                  <tr class="expandable-row" *ngIf="t.expanded && t?.waitingApprovePunches?.length > 0">
                    <td colspan="5" class="expandable-content">
                      <div class="punches-panel">
                        <div class="punches-header">
                          <i class="fas fa-list"></i>
                          <span>Панчи на проверке ({{ t.waitingApprovePunches.length }})</span>
                        </div>
                        <div class="punches-list">
                          <div 
                            class="punch-item" 
                            *ngFor="let punch of t.waitingApprovePunches">
                            <div class="punch-info">
                              <div class="punch-cp">
                                <i class="fas fa-flag"></i>
                                <strong>КП {{ punch.minor }}</strong>
                              </div>
                              <div class="punch-details">
                                <span class="punch-distance">
                                  <i class="fas fa-ruler"></i>
                                  {{ formatDistance(punch.nearestDistance) }}
                                  <small>(±{{ punch.location?.accuracy?.toFixed() || 0 }}м)</small>
                                </span>
                                <span class="punch-time">
                                  <i class="fas fa-clock"></i>
                                  {{ punch.timestamp | date:'HH:mm:ss' }}
                                </span>
                              </div>
                            </div>
                            <button 
                              class="btn btn-approve" 
                              (click)="approve(punch, t); $event.stopPropagation()"
                              title="Подтвердить панч">
                              <i class="fas fa-check"></i>
                              <span>Подтвердить</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
  </div>
</div>

<!-- Индикатор загрузки -->
<div class="loading-overlay" *ngIf="isLoading">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p class="loading-text">Загрузка данных...</p>
  </div>
</div>

